module.exports = __webpack_public_path__ + "static/media/0.f5bfcb0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/0.png
// module id = 1176
// module chunks = 0